// src/firebase/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyCXWy7_8cxBVJSkHzzdj4KwNRf6jEPnRdM",
    authDomain: "zao-web-ab837.firebaseapp.com",
    projectId: "zao-web-ab837",
    storageBucket: "zao-web-ab837.firebasestorage.app",
    messagingSenderId: "167187357281",
    appId: "1:167187357281:web:a76215b2a8d3e3eaad5420",
    measurementId: "G-7HTN6CEV0Q"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };